import React, { Children } from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  initials: 'SM',
  stars: 5,
  quote: 'Compré un domingo a la noche. El lunes tenía todo el año organizado. Las 18 secuencias del Tomo 1 son exactamente lo que necesitaba.',
  name: 'Sebastián M.',
  location: 'Buenos Aires',
  level: 'Profesor Particular'
}, {
  initials: 'CR',
  stars: 5,
  quote: 'Los 80 guiones de corrección me cambiaron todo. El primer mes, tres alumnos resolvieron problemas técnicos que llevaban meses sin superar.',
  name: 'Claudia R.',
  location: 'Rosario',
  level: 'Profesora en Academia'
}, {
  initials: 'DP',
  stars: 5,
  quote: "El Tomo 3 de Musicalidad es único. Mis alumnos ahora bailan diferente con D'Arienzo que con Pugliese. Antes eso me llevaba meses, ahora 3 clases.",
  name: 'Diego P.',
  location: 'Córdoba',
  level: 'Profesor Independiente'
}, {
  initials: 'LP',
  stars: 5,
  quote: 'Mi tasa de retención pasó del 42% al 83%. Sin cambiar las clases técnicamente. Solo aplicando el Sistema de los 4 Pilares del Tomo 4.',
  name: 'Laura P.',
  location: 'Mendoza',
  level: 'Profesora de Tango'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-[#111111] py-12 sm:py-24 px-4 overflow-hidden" data-id="element-285">
      <div className="max-w-2xl mx-auto" data-id="element-286">
        <motion.div className="text-center mb-8 sm:mb-12" initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5
      }} data-id="element-287">
          <h2 className="text-2xl sm:text-4xl font-black text-white mb-2 sm:mb-3 leading-tight" data-id="element-288">
            Lo que dicen los profes{' '}
            <span className="text-[#C8962E]" data-id="element-289">que ya lo usan</span>
          </h2>
          <p className="text-gray-400 text-xs sm:text-base" data-id="element-290">
            +500 profesores de Argentina ya tienen su MegaPack
          </p>
        </motion.div>

        <motion.div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4" initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-40px'
      }} variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.08
          }
        }
      }} data-id="element-291">
          {testimonials.map((test, i) => <motion.div key={i} variants={{
          hidden: {
            opacity: 0,
            y: 16
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.4,
              ease: 'easeOut'
            }
          }
        }} className="relative bg-white/[0.02] border border-white/[0.05] hover:border-[#C8962E]/30 rounded-2xl p-4 sm:p-5 flex flex-col gap-3 transition-colors duration-300 group" data-id="element-292">
              <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#C8962E]/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-293" />

              <div className="flex items-center gap-2.5" data-id="element-294">
                <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-[#C8962E]/10 border border-[#C8962E]/30 flex items-center justify-center text-[#C8962E] font-black text-[10px] sm:text-xs flex-shrink-0" data-id="element-295">
                  {test.initials}
                </div>
                <div className="min-w-0" data-id="element-296">
                  <div className="flex items-center gap-1.5" data-id="element-297">
                    <span className="text-white font-bold text-xs sm:text-sm leading-tight" data-id="element-298">
                      {test.name}
                    </span>
                    <span className="text-[#C8962E] text-[8px] sm:text-[10px] tracking-wider" data-id="element-299">
                      {'⭐'.repeat(test.stars)}
                    </span>
                  </div>
                  <div className="text-gray-500 text-[10px] sm:text-[11px]" data-id="element-300">
                    📍 {test.location} · {test.level}
                  </div>
                </div>
              </div>

              <p className="text-gray-300 text-xs sm:text-sm leading-relaxed italic relative z-10" data-id="element-301">
                <span className="text-[#C8962E]/30 text-xl absolute -top-1.5 -left-0.5 -z-10 font-serif" data-id="element-302">
                  "
                </span>
                {test.quote}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}